var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".close_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "close_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "close_svg__st1",
    d: "M21.21 19.79 13.42 12l7.79-7.79c.39-.39.39-1.03 0-1.42-.19-.19-.44-.29-.71-.29s-.52.1-.71.29L12 10.58 4.21 2.79c-.19-.19-.44-.29-.71-.29s-.52.1-.71.29c-.39.39-.39 1.03 0 1.42L10.58 12l-7.79 7.79c-.39.39-.39 1.03 0 1.42.19.19.44.29.71.29s.52-.1.71-.29L12 13.42l7.79 7.79c.19.19.44.29.71.29s.52-.1.71-.29c.39-.39.39-1.03 0-1.42z"
  })));
};
export default SvgClose;